<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
  } from "sveltestrap";

  import { paramsService } from "../services";
  import type { Fn } from "../global";
  import type { Param } from "../Model/Param";

  const dispatch = createEventDispatcher();

  let size = "xs";
  let name = null;
  let param: Param;
  let showButton = false;

  export let open;
  export let type;
  export let editParam: Param;
  export let removeButton;

  open = false;
  type = null;
  removeButton = false;

  $: load(editParam);

  const toggle = () => {
	  size = 'xs';
	  open = !open;
	};

  async function save() {
    
    let response = await paramsService.saveParam(param);

    if (response) {
      dispatch("addParam", param);
      editParam = null;
      open = false;
    }
  }

  async function remove() {
    if (!confirm("¿Esta seguro de querer eliminar el parámetro?")) return;

    let response = await paramsService.removeParam(param);

    if (response) {
      dispatch("removeParam", param);
      editParam = null;
      open = false;
    }
  }

  function load(editParam) {
    param = editParam;
    showButton = removeButton;
  }
</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar parámetro</ModalHeader>
  <ModalBody>
    {#if param}
      <Form id="info">
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label for="exampleEmail">Nombre</Label>
              <Input type="text" bind:value={param.name} />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    {/if}
  </ModalBody>
  <ModalFooter>
    {#if removeButton && showButton}
      <Button color="danger" on:click={remove}>Eliminar</Button>
    {/if}
    <Button color="primary" on:click={save}>Guardar</Button>
  </ModalFooter>
</Modal>

<style>
</style>
